/* A11Y-5 (WCAG 4.1.3): live regions that announce content which is not a status.

   - Swiper (vendored swiper-bundle.min.js, initialised by a dozen theme components)
     marks every slide wrapper aria-live="polite" unless autoplay is on, and its
     slide-change notice aria-live="assertive". Lazy-loaded images, badges and prices
     inside product carousels were therefore read out as they appeared, and slide
     changes interrupted whatever was being read. The wrapper becomes "off" and the
     notice "polite" as soon as Swiper sets them.
   - Yotpo widgets mark vote counters and some links aria-live="polite". Those lose
     the attribute as they render; real status and alert regions are left alone.
   - Klaviyo sign-up popups (if one is ever installed here) get the same treatment
     as on lewkin.com: the countdown stops being live and the dialog is named by its
     headline. Inert when no Klaviyo form is present. */
(function () {
  if (!window.MutationObserver) return;

  function fixSwiper(root) {
    var scope = root.querySelectorAll ? root : document;
    scope.querySelectorAll('.swiper-wrapper[aria-live="polite"]').forEach(function (el) { el.setAttribute('aria-live', 'off'); });
    scope.querySelectorAll('.swiper-notification[aria-live="assertive"]').forEach(function (el) { el.setAttribute('aria-live', 'polite'); });
    if (root.nodeType === 1 && root.matches) {
      if (root.matches('.swiper-wrapper[aria-live="polite"]')) root.setAttribute('aria-live', 'off');
      if (root.matches('.swiper-notification[aria-live="assertive"]')) root.setAttribute('aria-live', 'polite');
    }
  }

  var YOTPO = '.yotpo [aria-live], .yotpo-widget-instance [aria-live], [class*="yotpo-"][aria-live]';
  function fixYotpo(root) {
    var scope = root.querySelectorAll ? root : document;
    scope.querySelectorAll(YOTPO).forEach(function (el) {
      var role = el.getAttribute('role');
      if (role === 'status' || role === 'alert') return;
      el.removeAttribute('aria-live');
      el.removeAttribute('aria-atomic');
    });
  }

  var FALLBACK_LABEL = 'Weekly offer';
  function headlineOf(form) {
    var best = '', bestSize = 0;
    var walker = document.createTreeWalker(form, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = (node.nodeValue || '').replace(/\s+/g, ' ').trim();
      if (text.length < 3 || text.length > 80) continue;
      var el = node.parentElement;
      if (!el || el.closest('[role="timer"], button, a, label, input, script, style')) continue;
      var size = parseFloat(window.getComputedStyle(el).fontSize) || 0;
      if (size > bestSize) { bestSize = size; best = text; }
    }
    return best.replace(/\*+$/, '').trim();
  }
  function fixKlaviyo(root) {
    var scope = root.querySelectorAll ? root : document;
    var forms = Array.prototype.slice.call(scope.querySelectorAll('form.klaviyo-form'));
    if (root.matches && root.matches('form.klaviyo-form')) forms.unshift(root);
    forms.forEach(function (form) {
      form.querySelectorAll('[role="timer"]').forEach(function (t) { if (t.getAttribute('aria-live') !== 'off') t.setAttribute('aria-live', 'off'); });
      var dialog = form.closest('[role="dialog"]');
      if (!dialog) return;
      var current = dialog.getAttribute('aria-label') || '';
      if (!current || current === 'POPUP Form' || dialog.getAttribute('data-a11y-label') === current) {
        var label = headlineOf(form) || FALLBACK_LABEL;
        if (label !== current) { dialog.setAttribute('aria-label', label); dialog.setAttribute('data-a11y-label', label); }
      }
    });
  }

  function fixAll(root) { fixSwiper(root); fixYotpo(root); fixKlaviyo(root); }

  function start() {
    fixAll(document);
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes') { if (r.target.nodeType === 1) fixAll(r.target); continue; }
        for (var j = 0; j < r.addedNodes.length; j++) { if (r.addedNodes[j].nodeType === 1) fixAll(r.addedNodes[j]); }
      }
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-live', 'aria-label'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
